import debounce from 'lodash/debounce'
import { DEFAULT_DEBOUNCE } from '../../../lib/const'

const SearchBar = ({ onChange, term }) => {
  const handleOnCHange = debounce(
    (e) => onChange(e.target.value === '' ? null : e.target.value),
    DEFAULT_DEBOUNCE,
  )

  return (
    <div className="grid-search-bar">
      <div>
        <form onSubmit={(event) => event.preventDefault()} className="search w-form">
          <input type="button" value="." className="search-button w-button" disabled />
          <input
            type="search"
            className="input w-input"
            maxLength="256"
            defaultValue={term}
            name="query"
            placeholder="Search by Order Name or Status..."
            id="search"
            required=""
            onChange={handleOnCHange}
          />
        </form>
      </div>
    </div>
  )
}

export default SearchBar
